import React from 'react';

import CodeForm from '@components/ModalComponents/ProfileUserForm/CodeForm';

import { useMutateSendCodeToNumber } from '@hooks/userProfile/useMutateSendCodeToNumber';
import { useMutateSentCode } from '@hooks/userProfile/useMutateSentCode';
import { useQuery2FaHistory } from '@hooks/userProfile/useQuery2FaHistory';

import { IOnClose, IOnSuccess } from '@interfaces/common/handlers';
import { ISendCodeForChangePasswordWith2Fa } from '@interfaces/user/userProfile';
import { PhoneNumber } from 'libphonenumber-js/types';

interface ITwoFaPhoneContainerProps extends Partial<IOnSuccess>, IOnClose {
	phoneNumber: PhoneNumber;
}

const TwoFaPhoneContainer = ({
	onClose,
	phoneNumber,
	onSuccess,
}: ITwoFaPhoneContainerProps) => {
	const {
		leftSeconds,
		isLoadingHistory,
	} = useQuery2FaHistory();

	const {
		sendCodeToNumber,
		isLoadingSendCodeToNumber,
	} = useMutateSendCodeToNumber();

	const {
		sendCode,
		isLoadingSendCode,
	} = useMutateSentCode({
		onSuccess: () => {
			if (onSuccess) onSuccess();

			onClose();
		},
	});

	const getCode = () => sendCodeToNumber({ number: phoneNumber });

	const sendForm = async ({ code }: ISendCodeForChangePasswordWith2Fa) => {
		await sendCode({
			number: phoneNumber,
			code,
		});
	};

	const isLoading = isLoadingHistory || isLoadingSendCodeToNumber || isLoadingSendCode;

	return (
		<CodeForm
			getCode={getCode}
			isLoading={isLoading}
			leftSeconds={leftSeconds}
			negativeHandler={onClose}
			sendForm={sendForm}
		/>
	);
};

export default TwoFaPhoneContainer;
